export default __webpack_public_path__ + "static/media/bg_funky.c4c7afef.svg";